import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { IEvent } from '../../types/global/helper';
import { FONT_ENUM } from '../../types/global/fonts.types';
import CalendarIcon from '../CustomSVGIcons/CalendarIcon';
import { GpsFixedOutlined, Payments } from '@mui/icons-material';
import { TextWithIcon } from '../TextWithIcon/TextWithIcon';
import { formatDateWithTimezone } from '../../utils/AppUtils';
import { EventLocationMap } from './EventLocationMap';

export interface IEventDetails {
    event: IEvent;
}

const EventDetails: React.FC<IEventDetails> = ({ event }) => {
    const { themeStyle } = useThemeContext();
    const locationText = event.location?.description || event.location?.address || '';
    const hideLocation = event.hide_location_until_ticket_purchase && !event.has_user_registered;

    return (
        <Stack>
            <Stack mt={2} mb={4}>
                <TextWithIcon
                    icon={<CalendarIcon fill={theme[themeStyle].tag_white} height={'20px'} width={'20px'} />}
                    text=" Dates & Location"
                />
                <Typography
                    style={{ fontFamily: FONT_ENUM.MAIN_MEDIUM, fontSize: 14, color: theme[themeStyle].tag_white }}>
                    {formatDateWithTimezone(event.event_start_date, event.timezone)}
                </Typography>
            </Stack>
            <Stack mb={4}>
                <TextWithIcon
                    icon={<GpsFixedOutlined sx={{ fontSize: 24, color: theme[themeStyle].tag_white }} />}
                    text="Location"
                />

                {hideLocation ? (
                    <Typography
                        style={{
                            fontFamily: FONT_ENUM.MAIN_MEDIUM,
                            fontSize: 14,
                            color: theme[themeStyle].grey,
                            fontStyle: 'italic',
                        }}>
                        Location revealed after ticket purchase
                    </Typography>
                ) : (
                    <>
                        <Typography
                            style={{
                                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                fontSize: 14,
                                color: theme[themeStyle].tag_white,
                            }}>
                            {locationText}
                        </Typography>

                        {event.location?.coordinates?.length === 2 && (
                            <Box mt={2} borderRadius={2} overflow="hidden">
                                <EventLocationMap
                                    lat={event.location.coordinates[1]}
                                    lng={event.location.coordinates[0]}
                                    locationName={event.location.short_name || locationText}
                                />
                            </Box>
                        )}
                    </>
                )}
            </Stack>

            <Stack mb={4}>
                <TextWithIcon
                    icon={<Payments sx={{ fontSize: 24, color: theme[themeStyle].tag_white }} />}
                    text="Refund Policy"
                />

                <Typography
                    style={{
                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        fontSize: 14,
                        color: theme[themeStyle].tag_white,
                        textTransform: 'capitalize',
                    }}>
                    {event.refund_policy}
                </Typography>
            </Stack>
        </Stack>
    );
};

export { EventDetails };
